import React from 'react';
import PropTypes from 'prop-types';
import PendingProductInstanceShape from '../../shapes/pending-product-instance';
import { translate } from 'react-i18next';
import AgGridReact from '../common/ag-table';
import { classes } from "./styles/table";
import DateTimeCellComponent from "../common/datetime-cell";
import ProductIDCellComponent from '../common/product-id-cell';

class PendingProductInstanceTableView extends React.Component {

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  onRowSelected = event => {
    const { onSelect, disabled } = this.props;
    if (!onSelect || disabled) {
      return null; // Ignore, functions aren't present to invoke
    }
    if (event.node.selected) {
      onSelect(event.data.uuid, event.data, event);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selected === this.props.selected) {
      return null;
    }
    if (!this.gridApi) {
      return null;
    }
    let { selected = [] } = this.props;
    selected = Array.isArray(selected) ? selected : [selected];
    this.gridApi.forEachNode(
      node => node.setSelected(selected.indexOf(node.data.hexObjectId) > -1)
    );
  }

  render() {
    const { t, items, emptyMessage, className } = this.props;
    return (
      <div
        className={`ag-theme-blue ${classes.table} ${className || ''}`}
      >
        <AgGridReact
          name="pending-product-instance"
          sizeColumnsToFit
          onGridReady={this.onGridReady}
          onRowSelected={this.onRowSelected}
          rowSelection="single"
          enableFilter
          enableSorting
          frameworkComponents={{
            DateTimeCellComponent,
            ProductIDCellComponent
          }}
          defaultColDef={{
            resizable: true
          }}
          columnDefs={[
            {
              field: 'time',
              headerName: t('table.timeHeader'),
              cellRenderer: 'DateTimeCellComponent'
            },
            {
              field: 'systemId',
              headerName: t('table.systemIdHeader')
            },
            {
              field: 'productId',
              headerName: t('table.productIdHeader'),
              cellRenderer: 'ProductIDCellComponent'
            },
            {
              field: 'ipAddress',
              headerName: t('table.ipAddressHeader')
            },
            {
              field: 'declinedFormatted',
              headerName: t('table.declinedHeader')
            }
          ]}
          identifier="hexObjectId"
          items={
            items
              .map(
                item => ({
                  ...item,
                  declinedFormatted: (item.declined || false).toString()
                })
              )
          }
          localeText={{
            noRowsToShow: emptyMessage || t('table.emptyMessage')
          }}
        />
      </div>
    );
  }

}

PendingProductInstanceTableView.propTypes = {
  items: PropTypes.arrayOf(
    PendingProductInstanceShape.isRequired
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.string,
  emptyMessage: PropTypes.string,
  disabled: PropTypes.bool
};

export default translate(['pending'])(PendingProductInstanceTableView);



// WEBPACK FOOTER //
// ./src/views/pending-product-instance/table.js